import ISO639 from 'iso-639-1';

export const DEFAULT_LANGUAGE_CODE = ISO639.getCode('english');
